import React from 'react'
import { Field } from 'redux-form/immutable'
import PropTypes from 'prop-types'
import moment from 'moment'

import { MORNING_HOURS } from 'app/constants/notificationHours'
import Select from 'app/components/Select'
import { getTimeForSelection } from 'helpers/dateHelper'
import './styles.scss'

const bc = 'select-time'

const SelectTime = ({ options = MORNING_HOURS, name = 'time', label = 'Time:', normalize }) => (
  <Field
    name={name}
    component={Select}
    options={options}
    className={bc}
    classNameSelectWrapper={`${bc}__input`}
    labelClassName={`${bc}__label`}
    getLabel={hour => getTimeForSelection(moment(hour, 'h:m').format('hh:mm A'))}
    label={label}
    normalize={normalize}
  />
)

SelectTime.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  normalize: PropTypes.func,
  options: PropTypes.array.isRequired,
}

export default SelectTime
